"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayFilterLocalComponentParameters = void 0;
exports.ArrayFilterLocalComponentParameters = [
    {
        id: 'source',
        label: 'Source Array',
        description: 'Input Param - Source array to be filtered',
        type: 'json_array',
        paramType: 'ARRAY',
        required: true,
    },
    {
        id: 'exclude',
        label: 'Exclude Array',
        description: 'Input Param - Items to be excluded',
        type: 'json_array',
        paramType: 'ARRAY',
        required: true,
    },
    {
        id: 'target',
        label: 'Target Array',
        description: 'Output Param - Target to store the filtered array',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
];
//# sourceMappingURL=ArrayFilterLocal.js.map